import React from "react"
import ReactDOM from "react-dom"
import FullWidthImageCarousel from "./full-width-image-carousel"

export default class FullWidthImageCarouselModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<FullWidthImageCarousel {...this.modelJson} />, self.elem)
  }
}
